export interface A {}

export enum EmployeeStateType {
  Default = 0,
  Active = 1,
  Deactivated = 2,
}

export const EmployeeStateToBoolean: { [key: number]: boolean } = {
  1: true,
  2: false,
};

export const SearchFieldNames: string[] = [
  'fullName',
  'email',
  'cnp',
  'eid',
  'companyName',
];

export const SearchCrtIdToFieldName: { [key: number]: string } = {
  1: SearchFieldNames[0],
  2: SearchFieldNames[1],
  3: SearchFieldNames[2],
  4: SearchFieldNames[3],
  5: SearchFieldNames[4],
};
